import styled from "styled-components";
import referralRegister from "@/assets/images/referralRegister.png";

export const RefferalSection = styled.div`
  position: static;
  top: 0;
  width: 100%;
  height: 160px;
  background: linear-gradient(to right, #38c4f6 0%, #e10ff0 100%);
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RefferalSection2 = styled.div`
  position: static;
  top: 0;
  width: 100%;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ReferralTableSection = styled.div`
  width: 100%;
  min-height: 300px;
  padding: 20px;
  margin-block: 30px;
  border-radius: 15px;
`;
export const ReferralEventSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ReferralRegisterSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  min-height: 300px;
  background-image: url(${referralRegister});
  background-size: cover;
  border-radius: 15px;
  @media only screen and (max-width: 900px) {
    padding-inline: 20px;
    flex-direction: column;
    align-items: flex-start;
    height: 100px;
  }
  @media only screen and (max-width: 600px) {
    padding-inline: 10px;
    padding-block: 10px;
    width: 95%;
    align-self: center;
    align-items: center;
    margin: auto;
  }
`;
